import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBUaquHPuIZnY505JNREZ8kB2d6Z_fGPi8",
  authDomain: "bsi-bass.firebaseapp.com",
  databaseURL: "https://bsi-bass-default-rtdb.firebaseio.com",
  projectId: "bsi-bass",
  storageBucket: "bsi-bass.appspot.com",
  messagingSenderId: "582720210690",
  appId: "1:582720210690:web:d9cb5633aeead4421ea41b",
  measurementId: "G-1H71DRVBWK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const kbStorage = getStorage(app, 'gs://bsi-bass-knowledgebase');
export default app;
